import { Route } from '@angular/router';
import { CommandeEditComponent } from './commande-edit.component';

export const CommandeEditRouting: Route = {
  path: "edit",
  component: CommandeEditComponent,
  data: {
    breadcrumb: "Modifier une commande"
  }
}
